<div class="sheet-container">
  <div class="custom-divider"></div>
  <mat-list>
    <mat-list-item *ngFor="let log of data; index as i">
      <div class="time">
        <mat-icon mat-list-icon>south_west</mat-icon>
        {{ log.date | date: "HH:mm" }}
      </div>
      <div mat-line>{{ description(log, i) }}</div>
    </mat-list-item>
  </mat-list>
</div>
